const SECTION_CONSTANTS = {
  'My Practice Profile': {
    href: `/mpp`,
  },
};

const getMppBadgeLabel = (dayCount) => {
  let label = 'Days to Attest';

  if (dayCount === 1) {
    label = 'Day to Attest';
  }
  if (dayCount < 0) {
    label = dayCount === -1 ? 'Day Past Due' : 'Days Past Due';
  }

  return label;
};

const getMppBadgeVariant = (dayCount) => {
  let variant;

  if (dayCount >= 45) {
    variant = 'success';
  } else if (dayCount < 45 && dayCount > 10) {
    variant = 'warning';
  } else {
    variant = 'error';
  }

  return variant;
};

export const buildSection = (section) => {
  let badgeLabel;
  let badgeVariant;
  let badgeCount;

  if (section.sectionName === 'My Practice Profile') {
    badgeLabel = getMppBadgeLabel(section.daysToAttest);
    badgeVariant = getMppBadgeVariant(section.daysToAttest);
    badgeCount = Math.abs(section.daysToAttest);
  } else {
    badgeCount = section.requiresAttention;
    badgeVariant =
      SECTION_CONSTANTS[section.sectionName]?.badgeVariant || 'success';
    badgeLabel =
      section.requiresAttention === 1 ? 'Requires Action' : 'Require Action';
  }

  return {
    badgeCount,
    badgeLabel,
    badgeVariant,
    category: SECTION_CONSTANTS[section.sectionName]?.category,
    href: SECTION_CONSTANTS[section.sectionName]?.href,
    label: section.sectionName,
    subtitle: SECTION_CONSTANTS[section.sectionName]?.subtitle,
    alwaysShowSubtitle:
      SECTION_CONSTANTS[section.sectionName]?.alwaysShowSubtitle,
    subtitleVariant: SECTION_CONSTANTS[section.sectionName]?.subtitleVariant,
    toggle: SECTION_CONSTANTS[section.sectionName]?.toggle,
    success: section.success,
  };
};
